import BaseRepository from "./BaseRepository";
import AlertAPICall from "src/service/AlertAPICall";
import Constants from "src/support/Constants";
import store from "../storeWire";
import { setAlertTabCount } from "../store/slice/model/Alert";

class AlertRepository extends BaseRepository {
    getAlertListingByType = async (params) => {
        return await new AlertAPICall().alertListByType(params);
    };
    getAlertCount = async (currentTab) => {
        const params = {
            "startRow": 0,
            "pageSize": 0,
            "notificationType": "",
            "keyword": "",
            "searchType": ""
        }
        if (currentTab !== Constants.alertTypes.EOL) {
            params["notificationType"] = Constants.alertTypes.EOL;
            this.getAlertListingByType(params).then((pcnRes) => {
                store.dispatch(setAlertTabCount({ EOLCount: pcnRes.total }))
            })
        }
        if (currentTab !== Constants.alertTypes.PCN) {
            params["notificationType"] = Constants.alertTypes.PCN;
            this.getAlertListingByType(params).then((pcnRes) => {
                store.dispatch(setAlertTabCount({ PCNCount: pcnRes.total }))
            })
        }
        if (currentTab !== Constants.alertTypes.STOCK_ALERT) {
            let stockBody = {
                "manufacturerPartNumber": "",
                "customerPartNumber": "",
                "manufacturerName": "",
                "pageNumber": 0,
                "pageSize": 0
            }
            this.getStockAlertListing(stockBody).then((stockRes) => {
                store.dispatch(setAlertTabCount({ StockCount: stockRes.data.totalCount }))
            })
        }
    }
    getStockAlertListing = async (params) => {
        return await new AlertAPICall().stockAlertList(params);
    };
    deleteStockAlert = async (params) => {
        return await new AlertAPICall().deleteStockAlert(params);
    };
    getStockManufacturers = async () => {
        return await new AlertAPICall().getStockManufacturers();
    };

    exportAlertData = async (params) => {
        return await new AlertAPICall().exportData(params);
    };
    exportStockAlertData = async (params) => {
        return await new AlertAPICall().exportStockAlertData(params);
    };
    getStockAlertProducts = async (params) => {
        return await new AlertAPICall().getStockAlertProducts(params);
    };

}

export default AlertRepository;